var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('al-button',{staticStyle:{"display":"inline-block"},attrs:{"type":"text"},on:{"click":_vm.clickHandler}},[_vm._t("default"),_c('i',{staticClass:"iconfont",class:{'icon-arrow-up':_vm.isShow,'icon-arrow-down':!_vm.isShow},staticStyle:{"font-size":"12px"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-514aa824","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./UI/ShowMore/index.vue
// module id = 673
// module chunks = 0